<div class="feature" *ngIf="featureInfo$ | async as info">
  <app-start-trial-banner></app-start-trial-banner>
  <app-restricted-content [featureInfo]="info"></app-restricted-content>
</div>
